export enum ImageSource {
    Primary,
    Secondary,
    Tertiary,
}

// This is a number that was manually selected that made it look good in as many cases as possible
// This is currently used in the FeaturedCatalogCarousel.tsx file as such:
//   ```cardOffset={isMobile ? width / AUTOMATED_CAROUSEL_CARD_OFFSET_MODIFIER : 0}```
export const AUTOMATED_CAROUSEL_CARD_OFFSET_MODIFIER = 110;
export const FEATURED_CATALOG_CARD_MOBILE_SIZE_OFFSET_REDESIGN = 40;
export const FEATURED_CATALOG_CARD_MOBILE_PEEK_SIDES = 2;
export const FEATURED_CATALOG_CARD_DESKTOP_WIDTH_FIT_BUFFER = 1;
